import { useLocation } from 'react-router-dom';
import { QueryType } from '../apollo/graphqlSchema';
import { appRoutes } from '../../path';
import { assertCondition } from '../types';

const useQueryTypeFromLocation = (): QueryType | null => {
  const { pathname } = useLocation();

  assertCondition(
    pathname.startsWith(appRoutes.cohorts.routePrefix) ||
      pathname.startsWith(appRoutes.report.routePrefix),
  );

  if (pathname.startsWith(appRoutes.cohorts.routePrefix)) {
    return QueryType.CohortSample;
  }

  if (pathname.startsWith(appRoutes.report.query)) {
    return QueryType.Expression;
  }

  if (pathname.startsWith(appRoutes.report.funnel)) {
    return QueryType.Funnel;
  }

  if (pathname.startsWith(appRoutes.report.path)) {
    return QueryType.Path;
  }

  if (pathname.startsWith(appRoutes.report.retention)) {
    return QueryType.Retention;
  }

  if (pathname.startsWith(appRoutes.report.prediction)) {
    return QueryType.Prediction;
  }

  if (pathname.startsWith(appRoutes.report.dataTable)) {
    return QueryType.DataTable;
  }

  if (pathname.startsWith(appRoutes.report.significance)) {
    return QueryType.Significance;
  }

  return null;
};

export default useQueryTypeFromLocation;
